// Copyright (c) 2025 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.

const defaultStyles = {
  fontFamily: 'Source Sans Pro',
  h1: {
    fontSize: '96px',
    fontStyle: 'normal',
    fontWeight: 400,
  },
  h2: {
    fontSize: '60px',
    fontStyle: 'normal',
    fontWeight: 400,
  },
  h3: {
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: 600,
  },
  h4: {
    fontSize: '34px',
    fontStyle: 'normal',
    fontWeight: 600,
  },
  h5: {
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: 600,
  },
  h6: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
  },
  subtitle1: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
  },
  subtitle3: {
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 400,
  },
  body1: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
  },
  body2: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
  },
  caption: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
  },
  button: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
  },
  overline: {
    fontWeight: 400,
    fontSize: '10px',
    textTransform: 'uppercase',
  },
};

export default defaultStyles;
